module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/2-05e7f5703db9578b2303ea4b3f255914.jpg";